import { HttpClient } from '@angular/common/http';
import { inject, Injectable, signal } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class Command {
  private baseUrl: string = `${environment.apiUrl}/command`;
  private http: HttpClient = inject(HttpClient);

  //signals for state
  //TODO: Replace ANY with the right info
  isLoadingExternal = signal(false);
  errorMessageExternal = signal('');
  responseExternal = signal<any>(null);

  isLoadingMaintenance = signal(false);
  errorMessageMaintenance = signal('');
  responseMaintenance = signal<any>(null);

  isLoadingReboot = signal(false);
  errorMessageReboot = signal('');
  responseReboot = signal<any>(null);

  isLoadingActivation = signal(false);
  errorMessageActivation = signal('');
  responseActivation = signal<any>(null);

  getExtTunnelStatus(serialNumber: string): void {
    this.isLoadingExternal.set(true);
    this.errorMessageExternal.set('');
    this.responseExternal.set(null);

    this.http
      .get<any>(`${this.baseUrl}/get_ext_tunnel_status/board/${serialNumber}`)
      .subscribe({
        next: (data) => {
          this.responseExternal.set(data);
          this.isLoadingExternal.set(false);
        },
        error: (err) => {
          this.errorMessageExternal.set(
            'Failed to get Ext tunnel status' + ` Error: ${err.message}`,
          );
          this.isLoadingExternal.set(false);
        },
      });
  }

  stopExtTunnel(serialNumber: string): void {
    this.isLoadingExternal.set(true);
    this.errorMessageExternal.set('');
    this.responseExternal.set(null);

    this.http
      .get<any>(`${this.baseUrl}/stop_ext_tunnel/board/${serialNumber}`)
      .subscribe({
        next: (data) => {
          this.responseExternal.set(data);
          this.isLoadingExternal.set(false);
        },
        error: (err) => {
          this.errorMessageExternal.set(
            'Failed to stop ext tunnel' + ` Error: ${err.message}`,
          );
          this.isLoadingExternal.set(false);
        },
      });
  }

  startExtTunnel(serialNumber: string): void {
    this.isLoadingExternal.set(true);
    this.errorMessageExternal.set('');
    this.responseExternal.set(null);

    this.http
      .get<any>(`${this.baseUrl}/start_ext_tunnel/board/${serialNumber}`)
      .subscribe({
        next: (data) => {
          this.responseExternal.set(data);
          this.isLoadingExternal.set(false);
        },
        error: (err) => {
          this.errorMessageExternal.set(
            'Failed to start Ext tunnel' + ` Error: ${err.message}`,
          );
          this.isLoadingExternal.set(false);
        },
      });
  }

  startMaintenanceTunnel(serialNumber: string): void {
    this.isLoadingMaintenance.set(true);
    this.errorMessageMaintenance.set('');
    this.responseMaintenance.set(null);

    this.http
      .get<any>(
        `${this.baseUrl}/start_maintenance_tunnel/board/${serialNumber}`,
      )
      .subscribe({
        next: (data) => {
          this.responseMaintenance.set(data);
          this.isLoadingMaintenance.set(false);
        },
        error: (err) => {
          this.errorMessageMaintenance.set(
            'Failed to start maintenance tunnel' + ` Error: ${err.message}`,
          );
          this.isLoadingMaintenance.set(false);
        },
      });
  }

  stopMaintenanceTunnel(serialNumber: string): void {
    this.isLoadingMaintenance.set(true);
    this.errorMessageMaintenance.set('');
    this.responseMaintenance.set(null);

    this.http
      .get<any>(`${this.baseUrl}/stop_maintenance_tunnel/board/${serialNumber}`)
      .subscribe({
        next: (data) => {
          this.responseMaintenance.set(data);
          this.isLoadingMaintenance.set(false);
        },
        error: (err) => {
          this.errorMessageMaintenance.set(
            'Failed to stop maintenance tunnel' + ` Error: ${err.message}`,
          );
          this.isLoadingMaintenance.set(false);
        },
      });
  }

  getMaintenanceTunnelStatus(serialNumber: string): void {
    this.isLoadingMaintenance.set(true);
    this.errorMessageMaintenance.set('');
    this.responseMaintenance.set(null);

    this.http
      .get<any>(
        `${this.baseUrl}/get_maintenance_tunnel_status/board/${serialNumber}`,
      )
      .subscribe({
        next: (data) => {
          this.responseMaintenance.set(data);
          this.isLoadingMaintenance.set(false);
        },
        error: (err) => {
          this.errorMessageMaintenance.set(
            'Failed to get maintenance tunnel status' +
              ` Error: ${err.message}`,
          );
          this.isLoadingMaintenance.set(false);
        },
      });
  }

  rebootBox(serialNumber: string): void {
    this.isLoadingReboot.set(true);
    this.errorMessageReboot.set('');
    this.responseReboot.set(null);

    this.http
      .get<any>(`${this.baseUrl}/reboot_box/board/${serialNumber}`)
      .subscribe({
        next: (data) => {
          this.responseReboot.set(data);
          this.isLoadingReboot.set(false);
        },
        error: (err) => {
          this.errorMessageReboot.set(
            'Failed to send reboot box command' + ` Error: ${err.message}`,
          );
          this.isLoadingReboot.set(false);
        },
      });
  }

  triggerActivation(
    serialNumber: string,
    controllerId: number,
    shouldStartExternalTunnel: boolean,
  ): void {
    this.isLoadingActivation.set(true);
    this.errorMessageActivation.set('');
    this.responseActivation.set(null);

    this.http
      .post<any>(`${this.baseUrl}/trigger_activation`, {
        serialNumber,
        controllerId,
        shouldStartExternalTunnel,
      })
      .subscribe({
        next: (data) => {
          this.responseActivation.set(data);
          this.isLoadingActivation.set(false);
        },
        error: (err) => {
          this.errorMessageActivation.set(
            `Failed to send (de)activation trigger. Error: ${err.message}`,
          );
          this.isLoadingActivation.set(false);
        },
      });
  }
}
